export default __webpack_public_path__ + "static/media/energyActiveIcon.cb1c7c1b.svg";